import type { IconDefinition, IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';

export const dropdownIndicator: IconDefinition = {
  iconName: 'dropdown-indicator' as IconName,
  prefix: 'fac' as unknown as IconPrefix,
  icon: [
    24, 24, [], '',
    'M7 10l5 5 5-5z'
  ]
};